import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import { Apitoken, Authtoken , role_id , user_location } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const AddDailyProductionReports = () => {
  const [menu, setMenu] = useState(false);
  const [reportStatus, SetReportStatus] = useState([]);
  // const [usersLists, SetUsers] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [permission, setPermission] = useState({});

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));

   let season_id = localStorage.getItem("season_id");


  const formik = useFormik({
    initialValues: {
      season_id:season_id,
      id: "",
      date: defaultDate,
      shift: "",
      location: "",
      raw_material_consumption: "",
      decay: "",
      finished_products_net_weight: "",
      finished_pallets: "",
      pending_pallets: "",
      return: "",
      small_calibers: "",
      report_status: "",
    },
   onSubmit:  (values,{ setSubmitting }) =>{
      axios
        .post("/daily-production-reports/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Report");
          delete backendErrors['error'];
          setSubmitting(false);
          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
           
            setTimeout(() => {
              window.location.href = "/production-daily-reports";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }

        })
        .catch((error) => {
          console.log(error);
         
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {
        setPermission(FindModuleById(61)); 
console.log(permission);

    axios
      .get(`/helpers/daily-production-reports-status`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let materials_payment_status =
            response.data.data.materials_payment_status;
            let locations = materials_payment_status.map((customer, index) => ({
              label: customer.title,
              value: customer.id,
              key: `farmer-${index}`,
            }));
          SetReportStatus(locations);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let productslisting = response.data.data.locations;

          //let farmers = response.data.data.farmers;
          let locations = productslisting.map((customer, index) => ({
            label: customer.title,
            value: customer.id,
            key: `farmer-${index}`,
          }));
          //setLocationLoading(locations);
           if(role_id == 4){
              const filteredData = locations.filter(item => item.value == user_location);
              setLocationLoading(filteredData);
              formik.setFieldValue('location', user_location);
            }else{
              setLocationLoading(locations);
              formik.setFieldValue('location', user_location);
            }
          // if(role_id == 4){
          //   const filteredData = locations.filter(item => item.value == user_location);
          //   setLocationLoading(filteredData);
          //   //formik.setFieldValue('location', user_location);
          //   formik.values.location  = user_location;

          // }else{
          //   setLocationLoading(locations);
          //   formik.values.location  = 1;

          // }
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };
  
  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Daily Report</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-daily-reports">
                        Production Daily Report
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">Add Report</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.add == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Production Daily Report Info</h4>
                     <FormikProvider value={formik}>
                     <form action="#" onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Date</label>
                            <input
                              type="date"
                              name="date"
                              value={formik.values.date}
                              className={
                                backendErrors.date
                                  ? "form-input form-control input-error datetimepicker"
                                  : "form-input form-control datetimepicker"
                              }
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                                setDefaultDate(e.target.value)
                              }}
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.date && (
                                <span className="form-error mt-1">
                                  {backendErrors.date}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group status">
                            <label>Location</label>
                            {locationLoading.length > 0 && (
                              <Select
                              className="w-100"
                              value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                              name="location"
                              onChange={(selectedOption) => {
                              handleSelectChange("location", selectedOption);
                              //getCustomerGNN(selectedOption.value);
                              }}
                              onBlur={formik.handleBlur}
                              options={locationLoading}
                              placeholder="Select"
                                // value={formik.values.location}
                                // name="location"
                                // data={locationLoading.map((shipp) => ({
                                //   id: shipp.id,
                                //   text: shipp.title,
                                // }))}
                                // className={
                                //   backendErrors.location
                                //     ? "w-100 input-error"
                                //     : "w-100"
                                // }
                                // onChange={(e) => {
                                //   formik.handleChange(e);
                                //   customHandleInput(e);
                                // }}
                                // onBlur={formik.handleBlur}
                                // options={{
                                //   placeholder: "Select a Location",
                                // }}
                              />
                            )}
                            <small>
                              {backendErrors.location && (
                                <span className="form-error mt-1">
                                  {backendErrors.location}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Decay</label>
                           
                             <div className="input-group">
                                    <input 
                                     type="text"
                                     onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="decay"
                                      value={formik.values.decay}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Decay" aria-label="Decay" aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <span className="input-group-text" id="basic-addon2">KG</span>
                                    </div>
                                </div>

                            <small>
                              {backendErrors.decay && (
                                <span className="form-error mt-1">
                                  {backendErrors.decay}
                                </span>
                              )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Finished Pallets</label>
                            <input
                              type="text"
                              onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                              name="finished_pallets"
                              value={formik.values.finished_pallets}
                              className={
                                backendErrors.finished_pallets
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.finished_pallets && (
                                  <span className="form-error mt-1">
                                    {backendErrors.finished_pallets}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Return</label>
                            
                              <div className="input-group">
                                    <input  
                                     type="text"
                                     onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="return"
                                      value={formik.values.return}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Return" aria-label="Return" aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <span className="input-group-text" id="basic-addon2">KG</span>
                                    </div>
                                </div>
                            <small>
                              {backendErrors.return && (
                                <span className="form-error mt-1">
                                  {backendErrors.return}
                                </span>
                              )}
                            </small>
                          </div>

                          <div className="form-group status">
                            <label>Report Status</label>
                          
                            <Select
                             className="w-100"
                             value={reportStatus.find(option => option.value == formik.values.report_status) || null} // Ensure correct format
                             name="report_status"
                             onChange={(selectedOption) => {
                             handleSelectChange("report_status", selectedOption);
                             //getCustomerGNN(selectedOption.value);
                             }}
                             onBlur={formik.handleBlur}
                             options={reportStatus}
                             placeholder="Select"

                              // value={formik.values.report_status}
                              // name="report_status"
                              // data={reportStatus.map((shipp) => ({
                              //   id: shipp.id,
                              //   text: shipp.title,
                              // }))}
                              // className={
                              //   backendErrors.report_status
                              //     ? "w-100 input-error"
                              //     : "w-100"
                              // }
                              // onChange={(e) => {
                              //   formik.handleChange(e);
                              //   customHandleInput(e);
                              // }}
                              
                              // onBlur={formik.handleBlur}
                              // options={{
                              //   placeholder: "Select a Report Status",
                              // }}
                            />
                            <small>
                              {backendErrors.report_status && (
                                  <span className="form-error mt-1">
                                    {backendErrors.report_status}
                                  </span>
                                )}
                            </small>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Shift (1 ot 2)</label>
                            <input
                               type="text"
                               onKeyPress={(event) => {
                                    if (!/^[0-9]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                  }}
                              name="shift"
                              value={formik.values.shift}
                              className={
                                backendErrors.shift
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.shift && (
                                <span className="form-error mt-1">
                                  {backendErrors.shift}
                                </span>
                              )}
                            </small>
                          </div>

                          <div className="form-group">
                            <label>Raw Material Consumption</label>
                           
                                <div className="input-group">
                                    <input  
                                     type="text"
                                     onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="raw_material_consumption"
                                      value={formik.values.raw_material_consumption}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Raw Material Consumption" aria-label="Raw Material Consumption" aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <span className="input-group-text" id="basic-addon2">KG</span>
                                    </div>
                                </div>
                            <small>
                              {backendErrors.raw_material_consumption && (
                                  <span className="form-error mt-1">
                                    {backendErrors.raw_material_consumption}
                                  </span>
                                )}
                            </small>
                          </div>

                          <div className="form-group">
                            <label>Finished Products Net Weight</label>
                                <div className="input-group">
                                    <input 
                                     type="text"
                                     onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="finished_products_net_weight"
                                      value={formik.values.finished_products_net_weight}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Finished Products Net Weight" aria-label="Finished Products Net Weight" aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <span className="input-group-text" id="basic-addon2">KG</span>
                                    </div>
                                </div>
                            <small>
                              {backendErrors.finished_products_net_weight && (
                                  <span className="form-error mt-1">
                                    {backendErrors.finished_products_net_weight}
                                  </span>
                                )}
                            </small>
                          </div>
                          <div className="form-group">
                            <label>Pending Pallets</label>
                            <input
                              type="text"
                              onKeyPress={(event) => {
                                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                    event.preventDefault();
                                  }
                                }}
                              name="pending_pallets"
                              value={formik.values.pending_pallets}
                              className={
                                backendErrors.pending_pallets
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                              
                              onBlur={formik.handleBlur}
                            />
                            <small>
                              {backendErrors.pending_pallets && (
                                  <span className="form-error mt-1">
                                    {backendErrors.pending_pallets}
                                  </span>
                                )}
                            </small>
                          </div>

                          <div className="form-group">
                            <label>Small Calibers</label>
                              <div className="input-group">
                                    <input 
                                     type="text"
                                     onKeyPress={(event) => {
                                        if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                          event.preventDefault();
                                        }
                                      }}
                                      name="small_calibers"
                                      value={formik.values.small_calibers}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="Small Calibers" aria-label="Small Calibers" aria-describedby="basic-addon2" />
                                    <div className="input-group-append">
                                        <span className="input-group-text" id="basic-addon2">KG</span>
                                    </div>
                                </div>
                            <small>
                              {backendErrors.small_calibers && (
                                  <span className="form-error mt-1">
                                    {backendErrors.small_calibers}
                                  </span>
                                )}
                            </small>
                          </div>
                        </div>
                      </div>
                      <small>
                        {backendErrors.status  && (
                          <span className="form-error mt-1">
                            {backendErrors.status}
                          </span>
                        )}

                        
                    
                      </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={formik.isSubmitting}
                        >
                          Add Report
                        </button>
                      </div>
                    </form>
                     </FormikProvider>
                    
                  </div>
                )}``
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddDailyProductionReports;
